import { generateUrls } from '@hooks/useCampaignQuote'

import type { CampaignQuoteModel, UserModel } from '@models/types'

import CompactList from '../CompactList'
import LargeList from '../LargeList'

interface QuoteProps {
  campaignQuote: CampaignQuoteModel,
  canManageQuotes: boolean,
  currentUser: UserModel,
  displayMode: string,
  isCampaignManager?: boolean,
}

const Quote = (props: QuoteProps) => {
  const {
    campaignQuote, canManageQuotes, currentUser, displayMode, isCampaignManager,
  } = props

  const { editCampaignQuoteUrl } = generateUrls(campaignQuote, {
    prefixRoute: `campaigns/${campaignQuote?.campaign_id}/edit`,
  })

  const ListComponent = displayMode === 'compact-list' ? CompactList : LargeList

  return (
    <ListComponent
      campaignQuote={campaignQuote}
      currentUser={currentUser}
      href={canManageQuotes ? editCampaignQuoteUrl : ''}
      // @ts-expect-error TS2322
      isCampaignManager={isCampaignManager}
      key={campaignQuote.id}
    />
  )
}

export default Quote
